
/**
 * Used when sending a param to the FUIStackedPageService
 */
export class ReportParams {

    readonly params: any;

    public static isInstance(object: any): boolean {
        return object != undefined && object instanceof ReportParams;
    }

    constructor(params?: any) {
        this.params = params;
    }
}
